import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="text-2xl font-heading font-bold text-primary-400">爆料</span>
              <span className="text-2xl font-heading font-bold text-background-50">网</span>
            </Link>
            <p className="text-secondary-300 text-sm leading-relaxed">
              第一手独家爆料资讯平台，汇聚全网最新独家爆料内容。关注爆料网，掌握你不知道的内幕真相。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-secondary-300 hover:text-primary-400 text-sm transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-secondary-300 hover:text-primary-400 text-sm transition-colors">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-secondary-300 hover:text-primary-400 text-sm transition-colors">
                  口碑评价
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-secondary-300 hover:text-primary-400 text-sm transition-colors">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关注我们</h4>
            <div className="flex gap-3 mb-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line"></i>
              </a>
            </div>
            <p className="text-secondary-400 text-xs">联系邮箱: tips@baoliaowang.com</p>
          </div>
        </div>

        <div className="border-t border-secondary-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-secondary-400 text-xs">
            &copy; 2018-2026 爆料网 BaoLiaoWang.com 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-secondary-400 hover:text-secondary-200 text-xs transition-colors">隐私政策</a>
            <a href="#" className="text-secondary-400 hover:text-secondary-200 text-xs transition-colors">用户协议</a>
            <a href="#" className="text-secondary-400 hover:text-secondary-200 text-xs transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}